<!-- @format -->

<sis-basic-grouping-panel [heading]="studyYearName" [level]="level">
  @if (hasMissingPayments) {
    <sis-tiny-badge variant="danger" class="header-badge">
      {{ "STUDY_RIGHTS.TUITION_FEE_PAYMENT_MISSING" | translate }}
    </sis-tiny-badge>
  }
  <sis-description-list [columnCount]="1">
    <dl>
      @for (registration of termRegistrations; track registration) {
        <ng-template #listItem>
          <dt class="sis-label" [attr.data-cy]="'registration-term'">{{
            studyTermNamesByTermIndex.get(registration.studyTerm.termIndex)
          }}</dt>
          <dd [attr.data-cy]="'registration-item'">
            <sis-description-list-compact>
              <dl>
                <ng-template #compactListItem>
                  <dt class="sis-label colon" [attr.data-cy]="'registration-item-label'">{{
                    "STUDY_RIGHTS.TERM_REGISTRATION" | translate
                  }}</dt>
                  <dd class="sis-value">
                    {{ "STUDY_RIGHTS.REGISTRATION." + (registration.termRegistrationType || "MISSING") | translate }}
                    @if (registration.statutoryAbsence) {
                      <ng-container>, {{ "STUDY_RIGHTS.STATUTORY_ABSENCE" | translate }}</ng-container>
                    }
                  </dd>
                </ng-template>
                <ng-template #compactListItem>
                  <dt class="sis-label colon" [attr.data-cy]="'registration-item-label'">{{
                    "STUDY_RIGHTS.REGISTRATION_DATE" | translate
                  }}</dt>
                  <dd class="sis-value">{{ registration.registrationDate | localDateFormat }}</dd>
                </ng-template>
                @if (registration.previousRegistrationType) {
                  <ng-template #compactListItem>
                    <dt class="sis-label colon" [attr.data-cy]="'registration-item-label'">{{
                      "STUDY_RIGHTS.PREVIOUS_TERM_REGISTRATION" | translate
                    }}</dt>
                    <dd class="sis-value">
                      {{ "STUDY_RIGHTS.REGISTRATION." + registration.previousRegistrationType | translate }},
                      {{ registration.previousRegistrationDate | localDateFormat }}
                    </dd>
                  </ng-template>
                }
                @if (hasTuitionFeeObligationByTermIndex.get(registration.studyTerm.termIndex)) {
                  <ng-template #compactListItem>
                    <dt class="sis-label colon" [attr.data-cy]="'registration-item-label'">{{
                      "STUDY_RIGHTS.TUITION_FEE_PAYMENT" | translate
                    }}</dt>
                    <dd class="sis-value">
                      <sis-icon
                        [icon]="registration.tuitionFeePaymentState === 'PAID' ? 'check' : 'fail'"
                        [color]="registration.tuitionFeePaymentState === 'PAID' ? 'success' : 'danger'"></sis-icon>
                      {{ "STUDY_RIGHTS.TUITION_FEE_PAYMENT_STATE." + (registration.tuitionFeePaymentState || "OUTSTANDING") | translate }}
                    </dd>
                  </ng-template>
                }
              </dl>
            </sis-description-list-compact>
          </dd>
        </ng-template>
      }
    </dl>
  </sis-description-list>
</sis-basic-grouping-panel>
